<template>
  <v-container class="users-list">
    <v-card>
    <v-card-title>
      <h3>Users List</h3>
    </v-card-title>
    <v-container>
      <v-card-media>
        <v-flex v-if="users.length > 0" class="row" v-for="(user, index) of users" :key="user.id">
          <v-flex xs2 md2 class="user-info">
            <v-text-field label="User Name" :readonly="true" v-model="user.username"></v-text-field>
          </v-flex>
          <v-flex xs3 md3 class="user-info">
            <v-text-field label="Email" :readonly="true" v-model="user.email"></v-text-field>
          </v-flex>
          <v-flex xs2 md2 class="user-info">
            <v-text-field label="Current Password" :readonly="true" v-model="user._password"></v-text-field>
          </v-flex>
          <v-flex xs2 md2 class="user-info">
            <v-text-field label="New Password" v-model="user.password"></v-text-field>
          </v-flex>
          <v-flex xs2 md1 class="user-info">
            <v-text-field label="Customer ID" v-model="user.cid"></v-text-field>
          </v-flex>
          <v-flex xs2 md2 class="user-info">
            <v-text-field label="URL" v-model="user.url"></v-text-field>
          </v-flex>
          <v-flex xs1 md1>
            <v-btn @click="updateUser(user)" class="font-weight-light" color="success">
              Update
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex class="row" v-if="users.length === 0">
          <v-flex xs12 md12>
            <h4 class="align-center text-center">Please wait...</h4>
          </v-flex>
        </v-flex>
      </v-card-media>
    </v-container>
    </v-card>
  </v-container>
</template>
<script>
import axios from './../api/index'
  export default {
    name: "UsersList",
    data: () => ({
      users: [],
    }),
    methods:{
      updateUser: function (user){
        axios.post('/auth/update-user-password', user)
            .then(response => {
              this.$toasted.show('Updated')
              this.getAllUsers()
            })
      },
      getAllUsers: function (){
        axios.post('/auth/users', {})
        // axios.post('/users', {})
            .then(response => {
              this.users = response.data
            })
      },
    },
    mounted() {
      this.getAllUsers()
    }
  }
</script>
<style>
.users-list .v-label.v-label--is-disabled.theme--light {
  /*left: 15px !important;*/
}
.users-list .row{
  margin-right: 0;
  margin-left: 0;
  gap: 8px;
}

.row .user-info {
  overflow: hidden;
}
</style>
